//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';
import validateAccountMixin from '@motionelements/core/src/components/mixins/validate-account.mixin.js';

export default {
  name: 'SubscribePromoButton',
  mixins: [validateAccountMixin],
  props: {
    subscribePlanLink: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({
      subscriptions: state => state.user.member.subscriptions,
    }),
    ...mapGetters({
      isResellerCustomer: 'user/isResellerCustomer',
      getPlanBilledYearly: 'subscription/getPlanBilledYearly',
    }),
    isCtaDisabled() {
      return this.hasSimilarSubscription || this.isLoggedInButUnactivated;
    },
    hasSimilarSubscription() {
      return _.get(this.getPlanBilledYearly, 'unlimited') && this.subscriptions?.includes('unlimited');
    },
  },
  methods: {
    onClickCta() {
      if (this.hasSimilarSubscription) {
        return false;
      }

      if (this.isResellerCustomer) {
        return false;
      }

      if (!this.validateAccount()) {
        return;
      }

      window.location.href = this.subscribePlanLink;
    },
  },
};
